import {Link, useParams} from "react-router-dom";
import React, {useState} from "react";
import {BaseScopeModel, DeveloperScopeCardModel} from "../ScopeModel";
import {Card, CardContent, CardHeader, CardTitle} from "../../ui/card";

type ScopeCardProps = {
    scope: BaseScopeModel
}


export function BidderScopeCard({scope}: ScopeCardProps) {

    const {project_id} = useParams<string>();

    return (
        <Card key={scope.id} className="mb-4">
            <CardHeader>
                <CardTitle className="flex justify-between items-center">
                    <Link
                        className="text-lg font-semibold"
                        to={`/project/${project_id}/scopes/${scope.id}`}
                    >
                        #{scope.number} - {scope.title}
                    </Link>
                    {/*<QAControls<QAModel>*/}
                    {/*    controls={controls}*/}
                    {/*    qa={qa}*/}
                    {/*    onEdit={onEdit}*/}
                    {/*/>*/}
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="text-base mb-2">{scope.description}</div>

            </CardContent>
        </Card>
    );
}